import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import UpdateHeadhunterCandidateInfo from '../../_lib/UpdateCandidateInfo';

import { fetchApplication } from '@/redux/actions/applications';

const UpdateCandidateInfo = (props) => {
  const { orgId, applicationId } = useParams();
  const { applicationEntities } = useSelector((state) => ({
    applicationEntities: state.applications.entities,
  }));
  const dispatch = useDispatch();

  useEffect(() => {
    if (orgId && applicationId) {
      dispatch(fetchApplication(orgId, applicationId));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orgId, applicationId]);

  return applicationEntities[applicationId]?.headhunterType ? (
    <UpdateHeadhunterCandidateInfo {...props} />
  ) : null;
};

export default UpdateCandidateInfo;
